import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer'; // Import Footer
import HomePage from './pages/HomePage';
import ProductGallery from './pages/ProductGallery';
import ProductDetails from './pages/ProductDetails';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import PrivateRoute from './components/PrivateRoute';
import CartPage from './pages/CartPage';
import OrderConfirmation from './pages/OrderConfirmation';

function App() {
    return (
        <Router>
            <div className="min-h-screen bg-gray-50 flex flex-col">
                <Navbar />
                <main className="flex-grow">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/products" element={<ProductGallery />} />
                        <Route path="/products/:id" element={<ProductDetails />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
                        <Route path="/admin/products" element={<PrivateRoute><AdminProducts /></PrivateRoute>} />
                        <Route path="/cart" element={<CartPage />} />
                        <Route path="/order-confirmation" element={<OrderConfirmation />} />
                    </Routes>
                </main>
                <Footer />
                <ToastContainer position="bottom-right" autoClose={3000} />
            </div>
        </Router>
    );
}

export default App;